// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBar_wrapper__22bb6"};